/* drl-promo-rotate — two states in one row, swapped by a crossfade.

   The announcement bar shows the offer ("AKÁR 40% · Nyárzáró Árak") and the
   countdown in the same 38-42px row; there is no room for both on a phone, so
   they take turns. This is not the Dawn slideshow: nothing slides, the height
   never changes, there is no aria-live region announcing every swap, and the
   children are stacked in one grid cell (CSS in drl-promo-countdown.css).

   <drl-promo-rotate data-cadence="4"> <p class="is-on">offer</p> <p>clock</p> </drl-promo-rotate>

   Stops on the first child when the clock inside says it expired, and does
   not tick while the tab is hidden. */

class DrlPromoRotate extends HTMLElement {
  connectedCallback() {
    this.states = Array.from(this.children);
    if (this.states.length < 2) return;
    this.index = Math.max(0, this.states.findIndex((el) => el.classList.contains('is-on')));
    this.cadence = Math.max(2, Number(this.dataset.cadence) || 4) * 1000;

    this.onExpired = () => this.stop();
    this.addEventListener('drl-countdown:expired', this.onExpired);
    this.onVisible = () => (document.hidden ? this.pause() : this.play());
    document.addEventListener('visibilitychange', this.onVisible);
    // drl-countdown.js runs first: a clock that was already past its end when
    // it upgraded has fired `expired` before this element existed (a cached
    // page served after the end time). Read its state instead of waiting.
    const clock = this.querySelector('drl-countdown');
    const epoch = clock && Number(clock.dataset.epoch);
    if ((clock && clock.classList.contains('is-expired')) || (epoch && epoch * 1000 <= Date.now())) {
      this.stop();
      return;
    }
    this.play();
  }

  disconnectedCallback() {
    this.pause();
    document.removeEventListener('visibilitychange', this.onVisible);
  }

  play() {
    if (this.stopped) return;
    this.pause();
    this.timer = setInterval(() => this.show((this.index + 1) % this.states.length), this.cadence);
  }

  pause() {
    clearInterval(this.timer);
  }

  stop() {
    this.stopped = true;
    this.pause();
    this.show(0);
    this.removeEventListener('drl-countdown:expired', this.onExpired);
  }

  show(i) {
    this.index = i;
    this.states.forEach((el, k) => el.classList.toggle('is-on', k === i));
  }
}

if (!customElements.get('drl-promo-rotate')) {
  customElements.define('drl-promo-rotate', DrlPromoRotate);
}
